// extracted by mini-css-extract-plugin
module.exports = {"TableHeader":"CseAttendance_TableHeader__2dkLT"};